<mat-progress-bar mode="indeterminate" [ngClass]="{
  'progress-bar' : true,
  'my-progress': isLoading,
  'legacy-input': legacyInput,
  'relative-position': relativePosition
}"></mat-progress-bar>
